// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {ResultsCount} from '~/GalleryPB/ResultsCount';
import {Typography} from '~library/atoms/Typography';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {mediumAndUp} from '~libSass/base/_exports.sass';
import {TopFiltersAB} from './AB4Across/TopFiltersAB';

const {top_of_page_img_desk: imgDesk, top_of_page_img_mob: imgMob} = window;

export const SeoHeader = ({
  title,
  numTemplates,
  filtersData,
  relatedCategories,
  onFilterDismiss,
  activeFilters,
  onClearAllFilters,
  renderFiltersAB,
  galleryUploadComponent,
}) => {
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${mediumAndUp})`);
  const seoDataObj = window.top_of_page_copy;
  const backgroundImageUrl = largeScreens ? imgDesk : imgMob;
  const backgroundImage = !!backgroundImageUrl && `url('${backgroundImageUrl}')`;
  const abFilterMargin = filtersData ? {marginBottom: '0.5rem'} : {};

  return (
    <>
      <div
        className={`gallery__seo-header${(largeScreens ? imgDesk : imgMob) ? '--bg-img' : ''}`}
        style={{backgroundImage, ...abFilterMargin}}
      >
        <div className="gallery__seo-header-seo-copy">
          <Typography
            className="gallery__gallery-title"
            variant={largeScreens ? 'header3' : 'header4'}
            as="h1"
            data-qa-id="galleryPageTitle"
          >
            {title}
          </Typography>
          <Typography
            className="gallery__seo-header-metadata"
            variant={largeScreens ? 'paragraph2' : 'paragraph3'}
            data-qa-id="gallerySeoHeaderMetadata"
          >
            {seoDataObj}
          </Typography>
        </div>
      </div>
      {window.webflow_content && (
        // biome-ignore lint/security/noDangerouslySetInnerHtml: existing error
        // biome-ignore lint/style/useNamingConvention: existing error
        <div id="seoheader_webflow" dangerouslySetInnerHTML={{__html: window.webflow_content}} />
      )}
      {renderFiltersAB
        ? <TopFiltersAB
            filtersData={filtersData}
            relatedCategories={relatedCategories}
            onFilterDismiss={onFilterDismiss}
            seoPage
            activeFilters={activeFilters}
            numTemplates={numTemplates}
            onClearAllFilters={onClearAllFilters}
            galleryUploadComponent={galleryUploadComponent}
          />
        : galleryUploadComponent}
      {largeScreens && numTemplates && !filtersData && (
        <ResultsCount numTemplates={numTemplates} seoHeader />
      )}
    </>
  );
};
